<template>
  <div
    data-testid="room-form"
    class="border border-transparent transition-colors duration-200"
    :class="{ 'border-red rounded-sm': $v.value.$anyError }"
  >
    <div
      class="flex items-center justify-between bg-cream px-2 sm:px-5 py-3 rounded-t-sm"
    >
      <h3 class="font-semibold">{{ label }}</h3>
      <button type="button" class="link" @click="$emit('delete', index)">
        <span class="sr-only">Remove</span>
        <div class="w-3 h-3">
          <IconCrossSmall />
        </div>
      </button>
    </div>
    <div
      class="px-2 sm:px-5 py-5 rounded-b-sm bg-cream bg-opacity-50 grid sm:grid-cols-2 gap-6 sm:gap-8"
    >
      <div class="space-y-2">
        <DimensionInput
          :id="`width-${index}`"
          label="Width"
          :value="value.width"
          :error="$v.value.width.$error"
          @input="(event) => emitInput(event.target.value, 'width')"
        />
        <DimensionInput
          :id="`length-${index}`"
          label="Length"
          :value="value.length"
          :error="$v.value.length.$error"
          @input="(event) => emitInput(event.target.value, 'length')"
        />
        <DimensionInput
          :id="`height-${index}`"
          label="Height"
          :value="value.height"
          :error="$v.value.height.$error"
          @input="(event) => emitInput(event.target.value, 'height')"
        />
      </div>
      <div class="space-y-2">
        <NumericSelect
          :id="`doors-${index}`"
          label="Doors"
          :value="value.doors"
          :max="6"
          @input="(event) => emitInput(event.target.value, 'doors')"
        />
        <NumericSelect
          :id="`windows-${index}`"
          label="Windows"
          :value="value.windows"
          :max="6"
          @input="(event) => emitInput(event.target.value, 'windows')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, decimal, minValue } from "vuelidate/lib/validators";
import DimensionInput from "../Inputs/DimensionInput.vue";
import NumericSelect from "../Inputs/NumericSelect.vue";
import IconCrossSmall from "../../../../templates/_includes/svg/icon-cross-small.svg";

export default {
  name: "RoomForm",

  components: { DimensionInput, NumericSelect, IconCrossSmall },

  mixins: [validationMixin],

  props: {
    index: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },

  methods: {
    emitInput(inputValue, key) {
      this.$v.value[key].$touch();
      this.$emit("input", {
        ...this.value,
        [key]: inputValue,
      });
    },
  },

  validations: {
    value: {
      width: {
        required,
        decimal,
        minValue: minValue(0),
      },
      length: {
        required,
        decimal,
        minValue: minValue(0),
      },
      height: {
        required,
        decimal,
        minValue: minValue(0),
      },
      doors: {},
      windows: {},
    },
  },
};
</script>
